/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsBackgroundSideBySideOptions } from './FxIdDomainSettingsBackgroundSideBySideOptions';
import {
    instanceOfFxIdDomainSettingsBackgroundSideBySideOptions,
    FxIdDomainSettingsBackgroundSideBySideOptionsFromJSON,
    FxIdDomainSettingsBackgroundSideBySideOptionsFromJSONTyped,
    FxIdDomainSettingsBackgroundSideBySideOptionsToJSON,
} from './FxIdDomainSettingsBackgroundSideBySideOptions';

/**
 * @type FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsSideBySide
 * Настройки для режима side-by-side
 * @export
 */
export type FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsSideBySide = FxIdDomainSettingsBackgroundSideBySideOptions;

export function FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsSideBySideFromJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsSideBySide {
    return FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsSideBySideFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsSideBySideFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsSideBySide {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsBackgroundSideBySideOptions(json)) {
        return FxIdDomainSettingsBackgroundSideBySideOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsSideBySideToJSON(json: any): any {
    return FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsSideBySideToJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsSideBySideToJSONTyped(value?: FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsSideBySide | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsBackgroundSideBySideOptions(value)) {
        return FxIdDomainSettingsBackgroundSideBySideOptionsToJSON(value as FxIdDomainSettingsBackgroundSideBySideOptions);
    }

    return {};
}

